export default {"src":"/_next/static/media/map.896de0c6.svg","height":679,"width":1084,"blurWidth":0,"blurHeight":0};